import { useQuery } from "@tanstack/react-query";
import { getCompanyLogo } from "app/api/company_api";

const useGetCompanyLogo = ({ companyId, enabled }) => {
  return useQuery({
    queryKey: ["company_id", companyId],
    queryFn: () => getCompanyLogo(companyId),
    enabled: enabled,
    initialData: {}
  });
};

export default useGetCompanyLogo;
